import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import moment from 'moment'

// Styles
import './view.scss'
// Utils
import { hasSubscriptionPermission } from '../../../utils/auth'
import { translation, enumtranslate } from '../../../utils/helpers'

// Actions
import { ValidateCVRAndPNumber, CreateSaveCustomer, getCustomers, getCustomer } from '../../../actions/customers'
import { getPriceLists } from '../../../actions/priceModel'
import { getAgreementsDeliveryInformation } from '../../../actions/settings'

// Components
import Delivery from '../../Settings/Delivery'
import HelpText from '../../../shared/components/HelpText'
import Phone from '../../../shared/components/Phone'

// contants
import { CarRentalSystemTypes } from '../../../constants'

import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Radio from '../../../shared/elements/radio'
import Switch from '../../../shared/elements/switch'
import Text from '../../../shared/elements/text'
import DateTime from '../../../shared/elements/datetime'
import DropDown from '../../../shared/elements/dropDown'
import Textarea from '../../../shared/elements/textarea'
import Actions from '../../../shared/elements/actions'
import Icon from '../../../shared/elements/icon'
import Label from '../../../shared/elements/label'
import PanelHeader from '../../../shared/elements/panelHeader'
import { ElementIcons } from '../../../shared/elements/icons'

class View extends Component {

  constructor (props) {
    super(props)
    this.state = {
      type: 'create',
      customer: {
        CustomerId: 0,
        CountryId: 0,
        Active: true,
        ForsiActive: false,
        ForsiSelf: false,
        ShowTransport: true,
        CompanyCVR: '',
        CompanyPhoneNumber: '',
        CompanyDepartment: 0,
        PhoneCode: this.props.phonecode,
        Notes: '',
        PNumber: '',
        OriginalShopName: '',
        contractTypeSelected: 0,
        RentLogContractTypeInfo: null,
        ContractTypeListFromRentLog: []
      },
      deliveryTimes: [],
      hasAgreementPriceModel: false,
      workProviderName: '',
      deliveryHourColSpan: '1'
    }
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onPhoneChange = this.onPhoneChange.bind(this)
    this.loadData = this.loadData.bind(this)
    this.addCustomer = this.addCustomer.bind(this)
    this.saveAddCustomer = this.saveAddCustomer.bind(this)
  }

  componentDidMount () {
    if (this.props.item/*  && this.props.item.CustomerId */) {
      this.loadData(this.props.item.CustomerId)
    }
  }

  componentWillReceiveProps (nextProps) {
    // console.log('view nextProps', nextProps.item, this.props.item)
    if (this.props.item.CustomerId !== nextProps.item.CustomerId) {
      this.loadData(nextProps.item.CustomerId)
    }
  }

  onChange (e) {
    e.persist()
    let value = e.target.value
    let name = e.target.name

    if (name === 'contractTypeSelected') {
      name = 'RentLogContractTypeInfo'
      if (value === 0) return
      let newRentLogContractInfo = {
        CustomerId: this.props.item.CustomerId,
        RentLogContractTypeOid: value,
        CompanyId: this.props.auth.user.ShopId
      }
      value = newRentLogContractInfo
    }
    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }
    this.setState({
      type: this.state.type,
      customer: {
        ...this.state.customer,
        [name]: value
      }
    }, () => {
      if (e.target.type === 'checkbox' || name === 'CompanyDepartment' || name === 'CountryId' || name === 'RentLogContractTypeInfo') {
        this.onBlur(e)
      }
    })
  }

  onPhoneChange (e) {
    let value = e.target.value
    let name = e.target.name
    if (e.target.name === 'PhoneNumber') {
      name = 'CompanyPhoneNumber'
      this.setState({
        customer: {
          ...this.state.customer,
          [name]: value
        }
      })
    } else {
      this.setState({
        customer: {
          ...this.state.customer,
          PhoneCode: {
            Id: Number(value.Id)
          }
        }
      }, () => { this.saveAddCustomer() })
    }
  }

  checkHasAgreementPriceModel () {
    if (this.state.PriceModels.length <= 0) return
    const pm = this.state.PriceModels.find((_) => _.AgreementConstraintId > 0)
    if (!pm || this.state.hasAgreementPriceModel) return
    this.setState({
      hasAgreementPriceModel: true,
      workProviderName: pm.WorkProviderName
    })
  }

  loadData (CustomerId) {
    if (CustomerId === undefined || CustomerId <= 0) return this.resetCreate()
    this.props.getPriceLists(CustomerId, 0)
      .then((res) => this.setState({ PriceModels: res.data }, () => this.checkHasAgreementPriceModel()))
      .catch((err) => console.log(err))
    this.props.getCustomer(CustomerId)
      .then((res) => this.setState({ type: 'edit', customer: res.data }),
      () => {
        window.toastr.error(translation('910'), translation('216'))
      })
    this.props.getAgreementsDeliveryInformation(CustomerId, this.props.auth.user.ShopId)
      .then((res) => this.setState({ deliveryTimes: res.data }))
      .catch((err) => console.log(err))
  }

  resetCreate () {
    let chainCountryId = null
    if (this.props.countries && this.props.auth.user.ChainCountry) {
      let country = this.props.countries.find(c => c.CountryName === parseInt(this.props.auth.user.ChainCountry))
      if (country) chainCountryId = country.Id
    }

    this.setState({
      type: 'create',
      customer: {
        CustomerId: 0,
        CompanyName: '',
        CompanyAddress: '',
        CountryId: chainCountryId,
        CompanyZipCode: '',
        CompanyCity: '',
        CompanyCVR: '',
        CompanyPhoneNumber: '',
        PhoneCode: this.props.phonecode,
        Active: true,
        ForsiActive: false,
        ForsiCustomerNumber: '',
        ForsiMinDate: '2017-01-01T00:00:00',
        ForsiSelf: false,
        DrivingTime: '',
        ShowTransport: true,
        AllowChangeDeliverytime: false,
        LogDateChanges: false,
        DebitorNumber: '',
        DefaultHours: 48,
        CompanyDepartment: 0,
        DeliveryCustomerHourPrices: [],
        Notes: '',
        PNumber: '',
        OriginalShopName: ''
      },
      deliveryTimes: [],
      hasAgreementPriceModel: false,
      workProviderName: '',
      deliveryHourColSpan: '1'
    })
  }

  saveAddCustomer () {
    let customer = this.state.customer

    if (customer.CustomerId > 0) {
      this.props.CreateSaveCustomer(this.state.customer).then((res) => {
        this.props.onSave(res.data, this.state.type)
        setTimeout(() => {
          this.props.getCustomers()
        }, 0)
      }, (err) => {
      // Toastr
        if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
          let errors = err.response.data.Errors
          let errText = ''
          for (let i = 0; i < errors.length; i++) {
            let dictKey = errors[i].DictionaryKey
            errText += '<br/>' + translation(dictKey)
          }
          window.toastr.error(translation(errText), translation('216'))
        } else {
          window.toastr.error(translation('13465'), translation('216'))
        }
      })
    }
    if (customer.CustomerId === undefined || customer.CustomerId === 0) {
      this.validateCvrAndPNumberNewCustomer()
    }
  }

  addCustomer () {
    const { customer, type } = this.state
    const { CreateSaveCustomer, onSave } = this.props
    CreateSaveCustomer(customer)
      .then((res) => onSave(res.data, type))
      .catch((err) => {
        if (!err.response.data.Errors) {
          window.toastr.error(translation('13465'), translation('216'))
        }
        const errText = err.response.data.Errors.map((e) => translation(e.DictionaryKey)).join('<br/>')
        window.toastr.error(errText, translation('216'))
      })
  }

  onBlur (e) {
    const propName = typeof e === 'string' ? e : e.target.name

    if (!this.state.customer.CustomerId || this.state.customer.CustomerId <= 0) {
      return this.validateCvrAndPNumberNewCustomer()
    }
    const { customer, type } = this.state

    /**
     * If current prop it returns the new value, else null
     * @param {String} prop Actual prop
     * @param {Any} value New value of prop
     */
    const valueOrNull = (prop, value) => {
      if (typeof propName === 'string') {
        return propName === prop ? value : null
      }
      return value
    }

    let data = {
      CustomerId: customer.CustomerId,
      Active: valueOrNull('Active', customer.Active),
      CompanyAddress: valueOrNull('CompanyAddress', customer.CompanyAddress),
      CompanyCity: valueOrNull('CompanyCity', customer.CompanyCity),
      CompanyCVR: valueOrNull('CompanyCVR', customer.CompanyCVR),
      CompanyDepartment: valueOrNull('CompanyDepartment', customer.CompanyDepartment),
      CompanyName: valueOrNull('CompanyName', customer.CompanyName),
      CompanyPhoneNumber: valueOrNull('CompanyPhoneNumber', customer.CompanyPhoneNumber),
      CompanyZipCode: valueOrNull('CompanyZipCode', customer.CompanyZipCode),
      CountryId: valueOrNull('CountryId', customer.CountryId),
      DebitorNumber: valueOrNull('DebitorNumber', customer.DebitorNumber),
      DrivingTime: valueOrNull('DrivingTime', customer.DrivingTime),
      ForsiActive: valueOrNull('ForsiActive', customer.ForsiActive),
      ForsiCustomerNumber: valueOrNull('ForsiCustomerNumber', customer.ForsiCustomerNumber),
      ForsiMinDateHasValue: valueOrNull('ForsiMinDate', true),
      ForsiMinDate: valueOrNull('ForsiMinDate', customer.ForsiMinDate),
      ForsiSelf: valueOrNull('ForsiSelf', customer.ForsiSelf),
      MustApprovePriceChanges: valueOrNull('MustApprovePriceChanges', customer.MustApprovePriceChanges),
      MustApproveAddon: valueOrNull('MustApproveAddon', customer.MustApproveAddon),
      Notes: valueOrNull('Notes', customer.Notes),
      OriginalShopName: valueOrNull('OriginalShopName', customer.OriginalShopName),
      PhoneCode: valueOrNull('CompanyPhoneNumber', customer.PhoneCode),
      PNumber: valueOrNull('PNumber', customer.PNumber),
      ShowReferredTo: valueOrNull('ShowReferredTo', customer.ShowReferredTo),
      ShowTransportHasValue: valueOrNull('ShowTransport', true),
      ShowTransport: valueOrNull('ShowTransport', customer.ShowTransport),
      WPDebitorNr: valueOrNull('WPDebitorNr', customer.WPDebitorNr),
      WPPriceApprovalRequired: valueOrNull('WPPriceApprovalRequired', customer.WPPriceApprovalRequired),
      RentLogContractTypeInfo: customer.RentLogContractTypeInfo
    }

    if (type === 'create' || !propName) {
      data = customer
    }

    const { CreateSaveCustomer, onSave } = this.props
    if (customer.CustomerId > 0) {
      CreateSaveCustomer(data)
        .then((res) => onSave(res.data, type))
        .catch((err) => {
          if (!err.response.data.Errors) {
            window.toastr.error(translation('13465'), translation('216'))
          }
          const errText = err.response.data.Errors.map((e) => translation(e.DictionaryKey)).join('<br/>')
          window.toastr.error(errText, translation('216'))
        })
    }
  }

  validateCvrAndPNumberNewCustomer () {
    const cvrAndPNumberDetails = {
      cvr: this.state.customer.CompanyCVR,
      countryId: this.state.customer.CountryId,
      pnumber: this.state.customer.PNumber
    }
    this.props.ValidateCVRAndPNumber(cvrAndPNumberDetails)
      .then((err) => {
        if (err.data !== undefined && err.data.Error !== null) {
          const key = err.data.Error.DictionaryKey
          let errorText = ''
          if (key !== 0) errorText += '<br />' + translation(key)
          window.toastr.error(translation(errorText), translation('216'))
        }
      })
  }

  onDateChange (e) {
    if (!moment.isMoment(e)) return
    const customer = { ...this.state.customer, ForsiMinDate: e }
    this.setState({ customer }, () => this.onBlur('ForsiMinDate'))
  }

  renderCompany () {
    const { customer, hasAgreementPriceModel, workProviderName } = this.state
    const IsPerformingCustomer = this.props.item.IsPerformingCustomer
    const disableEdit = IsPerformingCustomer
    const { countries, isCustomer } = this.props
    const wpName = workProviderName + ' ' + translation('13452')

    return (
      <Panel title={this.props.isCustomer ? translation('700') : translation('58')}>
        <DropDown
          name='CountryId'
          disabled={disableEdit}
          value={customer.CountryId}
          onChange={this.onChange}
          labelText={translation('1701')}
        >
          {countries.map((country, key) => {
            let label = translation(country.CountryName)
            return <option value={country.Id} key={key}>{label}</option>
          })}
        </DropDown>

        <Text name='CompanyCVR' value={customer.CompanyCVR || ''} onChange={this.onChange} onBlur={this.saveAddCustomer} labelText={translation('41')} disabled={disableEdit} />
        <Text name='PNumber' value={customer.PNumber || ''} onChange={this.onChange} onBlur={this.saveAddCustomer} labelText={translation('15222')} disabled={disableEdit} />
        <Text name='CompanyName' value={customer.CompanyName || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('30')} disabled={disableEdit} />
        <Text name='CompanyAddress' value={customer.CompanyAddress || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('25')} />
        <Text name='CompanyZipCode' value={customer.CompanyZipCode || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('40')} />
        <Text name='CompanyCity' value={customer.CompanyCity || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('37')} />

        <LabelWrapper labelText={translation('38')}>
          <Phone
            onChange={this.onPhoneChange}
            onBlur={() => this.onBlur('CompanyPhoneNumber')}
            code={customer.PhoneCode}
            number={customer.CompanyPhoneNumber} />
        </LabelWrapper>

        {IsPerformingCustomer && (
          <Text labelText={13452} helpText={1945} name='DebitorNumber' value={customer.DebitorNumber || ''} onChange={this.onChange} onBlur={this.onBlur} />
        )}
        {IsPerformingCustomer && hasAgreementPriceModel && (
          <Text labelText={wpName} helpText={1945} name='WPDebitorNr' value={customer.WPDebitorNr || ''} onChange={this.onChange} onBlur={this.onBlur} />
        )}
        {!isCustomer && (
          <Textarea name='Notes' onChange={this.onChange} value={customer.Notes || ''} onBlur={this.onBlur} labelText={translation('93')} />
        )}
        {IsPerformingCustomer && (
          <LabelWrapper labelText={16443}><Label>{customer.OriginalShopName}</Label></LabelWrapper>
        )}
        {!this.props.isCustomer && (
          <Switch name='Active' onChange={this.onChange} checked={customer.Active} labelText={translation('295')} />
        )}
      </Panel>
    )
  }

  renderSettings () {
    const { auth, isCustomer } = this.props
    if (isCustomer) return null
    if (this.props.item.IsPerformingCustomer) return null
    if (!hasSubscriptionPermission(auth, 10, 0)) return null
    const onClick = (e) => {
      const value = e.currentTarget.dataset.value
      if (value === 'yes' && !customer.WPPriceApprovalRequired || value === 'no' && customer.WPPriceApprovalRequired) {
        let errorText = translation('14745')
        errorText = errorText.replace(/\[WPName]/gi, this.state.workProviderName)
        window.toastr.error(errorText, translation('216'))
      }
    }

    const { customer, workProviderName } = this.state
    const wpName = workProviderName + ' ' + translation('13452')
    const priceApprovalHelpText = translation('14743')
    let wpApprovalTitle = translation('14742').replace(/\[WPName]/gi, workProviderName)
    let wpApporvalHelpText = translation('14744').replace(/\[WPName]/gi, workProviderName)

    const showCustomerCompanyType = !isCustomer && auth.user.DepartmentType === 2
    const usedRentLog = this.props.auth.carRentalSystem === CarRentalSystemTypes.RENTLOG

    let contractTypeListFromRentLog = []
    if (!customer.RentLogContractTypeInfo) contractTypeListFromRentLog.push({ Oid: 0, Name: translation('890') })

    customer.ContractTypeListFromRentLog && customer.ContractTypeListFromRentLog.map((val) => {
      contractTypeListFromRentLog.push({ Oid: val.Oid, Name: val.Name })
    })
    if (customer.RentLogContractTypeInfo && contractTypeListFromRentLog.length > 1) { contractTypeListFromRentLog.filter(x => x.Oid !== 0) }

    let contractTypeSelected
    customer.ContractTypeListFromRentLog && customer.ContractTypeListFromRentLog.map((val) => {
      if (customer.RentLogContractTypeInfo && customer.RentLogContractTypeInfo.RentLogContractTypeOid === val.Oid) contractTypeSelected = val.Oid
    })
    const contractTypeOptions = contractTypeListFromRentLog.map((b, index) => {
      return <option key={index} value={b.Oid}>{b.Name}</option>
    })

    return (
      <Panel title={translation('6')}>
        {showCustomerCompanyType && (
          <div className='control__group settings'>
            <label>{translation('14857')} <HelpText text={translation('14858')} /></label>
            <select name='CompanyDepartment'
              onChange={this.onChange}
              value={customer.CompanyDepartment !== null ? customer.CompanyDepartment : 0} >
              <option value={0}>{translation('161')}</option>
              <option value={1}>{translation('14779')}</option>
            </select>
          </div>
        )}

        <Text name='DrivingTime' value={customer.DrivingTime || ''} onChange={this.onChange} onBlur={this.onBlur} disabled={!hasSubscriptionPermission(this.props.auth, 10, 0)} labelText={translation('13449')} helpText={translation('308')} />
        <Switch name='ShowTransport' onChange={this.onChange} checked={customer.ShowTransport} labelText={translation('603')} helpText={translation('1944')} />

        {hasSubscriptionPermission(this.props.auth, 30) && this.props.auth.user.DepartmentType !== 1 && (
          <Switch name='MustApprovePriceChanges' onChange={this.onChange} checked={customer.MustApprovePriceChanges} labelText={translation('2044')} helpText={priceApprovalHelpText} />
        )}

        {hasSubscriptionPermission(this.props.auth, 30) && this.props.auth.user.DepartmentType !== 1 && (
          <Switch name='MustApproveAddon' onChange={this.onChange} checked={customer.MustApproveAddon} labelText={translation(16824)} helpText={translation(16825)} />
        )}

        {this.state.hasAgreementPriceModel && (
          <LabelWrapper labelText={wpApprovalTitle} helpText={wpApporvalHelpText}>
            <Radio id='WPPriceApprovalRequired_yes' name='WPPriceApprovalRequired' value='yes' onChange={this.onChange} checked={customer.WPPriceApprovalRequired} readOnly disabled labelText={translation('47')} onClick={onClick} />
            <Radio id='WPPriceApprovalRequired_no' name='WPPriceApprovalRequired' value='no' onChange={this.onChange} checked={!customer.WPPriceApprovalRequired} readOnly disabled labelText={translation('48')} onClick={onClick} />
          </LabelWrapper>
        )}

        <Text name='DebitorNumber' value={customer.DebitorNumber || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('13452')} helpText={translation('1945')} />
        {this.state.hasAgreementPriceModel && (
          <Text name='WPDebitorNr' value={customer.WPDebitorNr || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={wpName} helpText={translation('1945')} />
        )}
        {usedRentLog && <DropDown name='contractTypeSelected' value={contractTypeSelected} onChange={this.onChange} labelText={translation('18130')} >
          {contractTypeOptions}
        </DropDown>}
        {hasSubscriptionPermission(this.props.auth, 30) && (
          <Switch name='ShowReferredTo' onChange={this.onChange} checked={customer.ShowReferredTo} labelText={translation('14931')} helpText={translation('14932')} />
        )}
      </Panel>
    )
  }

  renderForsi () {
    if (this.props.item.IsPerformingCustomer) return null
    if (this.props.auth.permissions.ChainAssessmentSystem === 2) return null // DBS
    const { auth, isCustomer } = this.props
    if (isCustomer) return false
    const { customer } = this.state
    const showTime = false
    const closeOnSelect = true
    let date = customer.ForsiMinDate
    if (typeof date === 'undefined' || date === null || date === '') {
      date = window.CustomDate('2017-01-01T00:00:00')
    } else {
      date = window.CustomDate(date)
    }
    const inputProps = {
      name: 'ForsiMinDate',
      readOnly: true
    }
    return (
      <Panel title={translation('13438')}>
        <Switch name='ForsiActive' onChange={this.onChange} checked={customer.ForsiActive} labelText={translation('295')} />

        <Text
          name='ForsiCustomerNumber'
          value={customer.ForsiCustomerNumber || ''}
          onChange={this.onChange}
          onBlur={this.onBlur}
          disabled={customer.IsOwnShop || (auth.departmentType === 1 && !hasSubscriptionPermission(auth, 30))}
          labelText={translation('14803')}
          helpText={translation('1947')}
        />

        <DateTime
          inputProps={inputProps}
          dateFormat='DD-MM-YYYY'
          timeFormat={showTime}
          closeOnSelect={closeOnSelect}
          value={date}
          onChange={this.onDateChange.bind(this)}
          labelText={translation('388')}
          helpText={translation('1946')}
        />
      </Panel>
    )
  }

  renderRightRow () {
    return (
      <Col>
        {!this.props.isCustomer && this.renderContacts()}
        {!this.props.isCustomer && this.renderPrices()}
      </Col>
    )
  }

  renderPrices () {
    const { customer, PriceModels } = this.state
    const { auth } = this.props
    if (!hasSubscriptionPermission(auth, 10)) return
    if (customer.CustomerId === null || customer.CustomerId === 0) return
    if (typeof PriceModels === 'undefined') return null

    // Group lists.
    let groups = {
      Undefined: [],
      Insurance: [],
      Sales: [],
      Warranty: [],
      Private: [],
      Other: [],
      Complaint: [],
      Addon: [],
      Extra: [],
      Estimation: [],
      UnGrouped: []
    }
    let groupsBody = {
      Undefined: [],
      Insurance: [],
      Sales: [],
      Warranty: [],
      Private: [],
      Other: [],
      Complaint: [],
      Addon: [],
      Discounts: [],
      Extra: [],
      Estimation: [],
      UnGrouped: []
    }

    let paintCount = 0
    let bodyCount = 0

    for (let i = 0; i < PriceModels.length; i++) {
      let item = PriceModels[i]
      if ([4, 5, 8].indexOf(item.PriceType) !== -1 && !hasSubscriptionPermission(auth, 30)) continue
      if ([-1, 0, 1, 2, 3].indexOf(item.PriceType) !== -1 && !hasSubscriptionPermission(auth, 20)) continue
      if ([-10].indexOf(item.PriceType) !== -1 && !hasSubscriptionPermission(auth, 10)) continue
      let foundGroup = (item.Department === 1) ? groupsBody : groups
      if (foundGroup === groups) paintCount++
      if (foundGroup === groupsBody) bodyCount++
      switch (item.PriceType) {
        case -1: // Undefined
          foundGroup.Undefined.push(item)
          break
        case 0: // Other
          foundGroup.Other.push(item)
          break
        case 1: // Salescar
          foundGroup.Sales.push(item)
          break
        case 2: // Private
          foundGroup.Private.push(item)
          break
        case 3: // Warranty
          foundGroup.Warranty.push(item)
          break
        case 4: // Extra
          foundGroup.UnGrouped.push(item)
          break
        case 5: // Estimation
          if (item.Name !== null) {
            foundGroup.Insurance.push(item)
          } else {
            if (item.Department === 0) {
              groups.UnGrouped.push(item)
            }
          }
          break
        case 6: // Complaint
          foundGroup.Complaint.push(item)
          break
        case 8:
          foundGroup.Addon.push(item)
          break
        // case -10: // Discounts
        //   if (item.Department === 1) {
        //     foundGroup.Discounts.push(item)
        //   } else {
        //     foundGroup.UnGrouped.push(item)
        //   }
        //   break
      }
    }

    const renderGroup = (val, key) => {
      let groupTitle = translation(key)
      if (key === 'UnGrouped') {
        return (
          <div key={key}>
            {val.map(renderPrice)}
          </div>
        )
      } else if (key === 'Discounts') {
        return (
          <LabelWrapper key={key} labelText={translation('1197')}>
            {this.state.customer.Discounts !== null && this.state.customer.Discounts.map(renderDiscountList)}
          </LabelWrapper>
        )
      } else {
        return (
          <LabelWrapper labelText={groupTitle} key={key}>
            {val.length > 0 && val.map(renderPrice)}
          </LabelWrapper>
        )
      }
    }

    const renderDiscountList = (val, key) => {
      let text = translation(enumtranslate('OrderTypes', val.OrderType))
      if (val.IsAddonPrice && val.OrderType === 1) {
        text = translation('1396')
        return <Label key={key}><Link key='Addon' to={'/customers/' + customer.CustomerId + '/prices/discounts/' + val.Department + '/Addon'}>{text}</Link></Label>
      } else {
        if (val.OrderType === 1) text = translation('70')
        if (val.OrderType === 4) text = translation('2263')
        return <Label key={key}><Link key={val.OrderType} to={'/customers/' + customer.CustomerId + '/prices/discounts/' + val.Department + '/' + val.OrderType}>{text}</Link></Label>
      }
    }

    const renderPrice = (val, key) => {
      let text = (val.Name === null || val.Name === '') ? null : val.Name
      if (text !== null && (val.Brand !== null || val.WorkProviderName !== null)) {
        text += ' ('
        if (val.Brand !== null) {
          text += val.Brand
        }
        if (val.Brand !== null && val.WorkProviderName !== null) {
          text += '/'
        }
        if (val.WorkProviderName !== null) {
          text += val.WorkProviderName
        }
        text += ')'
      }
      let extraClass = !val.Active ? 'disabled' : ''
      let link = val.PriceModelId
      if (text === null) {
        switch (val.PriceType) {
          case 0:
            text = translation('73') // salescar
            break
          case 1:
            text = translation('71') // salescar
            break
          case 2:
            text = translation('785') // private
            break
          case 3:
            text = translation('13361') // warranty
            break
          case 4:
            text = translation('2224')
            link = 'extras/' + val.Department
            break
          case 5:
            text = translation('13363')
            link = 'estimation/' + val.Department
            break
          case 6:
            text = translation('301') // salescar
            break
          // case -10:
          //   if (val.Department !== 1) {
          //     text = translation('1197') // Discounts
          //     link = 'discounts/' + val.Department
          //   }
          //   break
        }
      }
      return <Label key={key}><Link className={extraClass} to={'/customers/' + customer.CustomerId + '/prices/' + link}>{text}</Link></Label>
    }

    const renderListHeader = (title) => {
      return <PanelHeader text={title} />
    }
    const renderGroups = (count, header, groups, bodyDiscounts) => {
      if (count === 0) return null
      return (
        <div>
          {renderListHeader(header)}
          {hasSubscriptionPermission(this.props.auth, 20) && renderGroup(groups['Undefined'], '2036')}
          {hasSubscriptionPermission(this.props.auth, 20) && renderGroup(groups['Insurance'], '13360')}
          {hasSubscriptionPermission(this.props.auth, 20) && renderGroup(groups['Sales'], '71')}
          {hasSubscriptionPermission(this.props.auth, 20) && renderGroup(groups['Warranty'], '13361')}
          {hasSubscriptionPermission(this.props.auth, 20) && renderGroup(groups['Private'], '785')}
          {hasSubscriptionPermission(this.props.auth, 20) && renderGroup(groups['Other'], '73')}
          {hasSubscriptionPermission(this.props.auth, 30) && renderGroup(groups['Complaint'], '301')}
          {hasSubscriptionPermission(this.props.auth, 30) && renderGroup(groups['Addon'], '1396')}
          {hasSubscriptionPermission(this.props.auth, 10) && renderGroup(groups['Discounts'], 'Discounts')}
          {renderGroup(groups['UnGrouped'], 'UnGrouped')}
        </div>
      )
    }

    let customTitle = !hasSubscriptionPermission(this.props.auth, 20) ? translation('1197') : translation('1172')
    return (
      <Panel title={customTitle}>
        <Actions>
          {!this.props.item.IsPerformingCustomer && (
          <Link to={'/customers/' + customer.CustomerId + '/prices'}>
            <div className='hint--left' aria-label={translation('2042')}>
              <Icon icon={ElementIcons.Edit} size='t' />
            </div>
          </Link>)}
        </Actions>

        {renderGroups(paintCount, translation('161'), groups, false)}
        {renderGroups(bodyCount, translation('788'), groupsBody, true)}
      </Panel>
    )
  }

  renderContacts () {
    let { customer } = this.state
    if (customer.CustomerId === undefined || customer.CustomerId === 0) return null
    // Render contact
    const renderContact = (val, key) => {
      if (!val.Active) return null
      return <Label key={key}><Link to={'/customers/' + customer.CustomerId + '/contacts/' + val.UserId}>{val.Name}</Link></Label>
    }
    // Return
    return (
      <Panel title={translation('13460')}>
        <Actions>
          <Link to={'/customers/' + customer.CustomerId + '/contacts'}>
            <div className='hint--left' aria-label={translation('2043')}>
              <Icon icon={ElementIcons.Edit} size='t' />
            </div>
          </Link>
        </Actions>

        {customer.Contacts !== undefined && customer.Contacts !== null ? customer.Contacts.map(renderContact) : undefined}
      </Panel>
    )
  }

  render () {
    // let classNameList = (this.state.type === 'edit') ? 'view_edit' : 'view_create'
    const { customer, deliveryTimes, type } = this.state
    let canRender = (customer.CustomerId > 0 &&
                     type === 'edit' &&
                     !this.props.isCustomer &&
                     hasSubscriptionPermission(this.props.auth, 10, 0) &&
                     this.props.auth.departmentType !== 1 &&
                     !this.props.item.IsPerformingCustomer
    )
    const onDeliveryHourLayoutChange = (colSpan) => {
      // console.log('update.....')
      this.setState({
        deliveryHourColSpan: colSpan
      })
    }
    return (
      <div>
        <Col>
          {this.renderCompany()}
        </Col>
        <Col>
          {this.renderSettings()}
          {this.renderForsi()}
        </Col>
        {type === 'edit' && this.renderRightRow()}
        <Col span='4'>
          {canRender && (<Delivery type='customer' isShop={false} CustomerId={customer.CustomerId} onLayoutChange={onDeliveryHourLayoutChange} />)}
          {canRender && (deliveryTimes.map((val, index) => {
            return <Delivery key={index} isShop isAgreement item={val} agreementId={val.PriceModelId} CustomerId={val.CustomerId} onLayoutChange={onDeliveryHourLayoutChange} />
          }))}
        </Col>
      </div>
    )
  }

}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode,
    phonecodes: state.common.phonecodes,
    countries: state.common.countries
  }
}

export default connect(mapStateToProps, {
  CreateSaveCustomer,
  getCustomers,
  getCustomer,
  getPriceLists,
  getAgreementsDeliveryInformation,
  ValidateCVRAndPNumber
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/Customers/View/index.js